import { render, staticRenderFns } from "./index.vue?vue&type=template&id=08513510&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Crumbs: require('/var/www/components/crumbs/crumbs.vue').default,ApplicationInstallment2: require('/var/www/components/application/application-installment2.vue').default,FeaturedBanks: require('/var/www/components/featured/featured-banks.vue').default,TextUniversal: require('/var/www/components/text/text-universal.vue').default})
